import { useQueryClient } from '@mint-lib/query-client';
import { Chat, Schedule } from '@mint-sdk/api-ai-assistant';
import { useAtom } from 'jotai';

import { useDeleteScheduledQueryMutation } from '../queries/schedule.js';
import {
  deleteScheduledQueryIdsAtom,
  isOpenDeleteDialogAtom,
} from '../store/scheduleDrawer.js';

export const useDeleteScheduledQueries = () => {
  const queryClient = useQueryClient();
  const [isOpenDeleteDialog, setIsOpenDeleteDialog] = useAtom(
    isOpenDeleteDialogAtom,
  );
  const [scheduledQueryIds, setScheduledQueriesIds] = useAtom(
    deleteScheduledQueryIdsAtom,
  );
  const { mutate: deleteScheduledQueryM } = useDeleteScheduledQueryMutation();

  const handleDeleteSelectedQueries = () => {
    if (!scheduledQueryIds?.length) {
      return;
    }

    scheduledQueryIds.forEach((queryId) => {
      deleteScheduledQueryM(queryId, {
        onSettled: async () => {
          await queryClient.invalidateQueries({
            queryKey: Schedule.getScheduleOptions({}).queryKey,
          });

          Chat.getChatList.invalidate(queryClient, { params: {} });

          setScheduledQueriesIds([]);
        },
      });
    });

    setIsOpenDeleteDialog(false);
  };

  const toggleDeleteDialog = () => {
    setIsOpenDeleteDialog((o) => !o);
  };

  return {
    isOpenDeleteDialog,
    setIsOpenDeleteDialog,
    toggleDeleteDialog,
    scheduledQueryIds,
    setScheduledQueriesIds,
    deleteScheduledQueries: handleDeleteSelectedQueries,
  };
};
